import './CreditTable.css';
import React from 'react';
import {lang} from '../../common/baseData';

function CreditTable(props) {

  return (
      <div id="credit-table" className="content content-page-holder">
        <div className="section-title">
          <h2>{props.title}</h2>
        </div>
        {
          props.subTitle !== null && props.subTitle.length > 0 ?
            <span className="text-content">{props.subTitle}</span> :
            <></>
        }
        <table className="table">
          <tbody>
          <tr>
            <td><b>{props.messages.WСT_T_BANK_COLUMN_TITLE}</b></td>
            <td><b>{props.messages.WСT_T_AMOUNT_COLUMN}</b></td>
            <td><b>{props.messages.WСT_T_GRACE_PERIOD}</b></td>
            <td><b>{props.messages.WСT_T_TERM}</b></td>
            <td><b>{props.messages.WСT_T_AGE}</b></td>
            <td><b>{props.messages.WСT_T_DEPOSIT}</b></td>
          </tr>
            {
              props.hasOwnProperty('credit') && typeof props.credit === 'object' && props.credit !== null ?
                Object.values(props.credit).map(item => (
                  <tr className="sort_tr" key={item.code}>
                    <td className={'credit_item_title'}>
                      <img src={item['image_src']} alt={item['name']}/>
                      <span>{item['name']}</span>
                    </td>
                    <td>{item.amount}</td>
                    <td>{item.grace_period}</td>
                    <td>До {item.term}</td>
                    <td>{item.age}</td>
                    <td>{item.deposit}%</td>
                  </tr>
                )) :
                <></>
            }
          </tbody>
        </table>
      </div>
  );
}

export default CreditTable;